import axios from "axios";
import { getQueryString } from "@/utils/tools";

const siteId = getQueryString("site_id");

const baseReq = axios.create({
  baseURL: `/platform/api/v1/plugin/tk`,
  timeout: 5000
});

baseReq.interceptors.response.use(res => {
  if (res.data.code === 200) {
    return res.data.data;
  } else {
    return Promise.reject(res.data);
  }
});

/**
 * 获取站点域名详细信息
 */
export const getSiteDomainDetail = userId => {
  return baseReq.get(`/${siteId}/getSiteDomainDetail`, {
    params: {
      userId
    }
  });
};

/**
 * 获取站点域名list
 */
export const getSiteDomainList = userId => {
  return baseReq.get(`/${siteId}/getSiteDomainList`, {
    params: {
      userId
    }
  });
};

/**
 * 手动检测
 */
export const checkDomain = userId => {
  return baseReq.get(`/${siteId}/checkDomain`, {
    params: {
      userId
    }
  });
};

/**
 * 自动生成
 */
export const autoProduceDomain = (userId, oldDomain) => {
  return baseReq.get(`/${siteId}/autoProduceDomain`, {
    params: {
      userId,
      oldDomain
    }
  });
};

/**
 * 切换域名
 */
export const changeDomain = (userId, data) => {
  return baseReq.put(`/${userId}/changeDomain/${siteId}`, data);
};

/**
 * 获取站点域名设置信息
 */
export const getDomainSetting = userId => {
  return baseReq.get(`/${siteId}/domainSetting`, {
    params: { userId }
  });
};

/**
 * 站点域名设置
 */
export const postDomainSetting = (userId, data) => {
  return baseReq.put(`/${userId}/domainSetting/${siteId}`, data, {
    jsonType: true
  });
};

/**
 * 校验接口推送的接口是否有效
 */
export const checkPushUrl = (pushUrl) => {
  return baseReq.get(`/domains/autocheck/pushurl`, {
    params: {
      pushUrl
    }
  })
} 


export const getIsBindWeixin = () => {
  return axios.get(`/kzplatform/api/user/isSubscribeKz`, {
    baseURL: ''
  })
}